import axios from "axios";
import { headersProvider } from "../apiHelpers";
import constants from "../constants";

export const getResourceFinances = ({
  parentResource,
  parentResourceId,
  page,
}) =>
  axios.get(`${constants.apiHost}/expenses/list`, {
    params: {
      parent: parentResource,
      parentId: parentResourceId,
      page,
    },
    headers: headersProvider(),
  });

export const createFinancialEntryApi = ({ expenseData }) =>
  axios.post(
    `${constants.apiHost}/expenses/create-expense`,
    {
      ...expenseData,
    },
    {
      headers: headersProvider(),
    },
  );

export const getExpenseDetails = ({ expenseId }) =>
  axios.get(`${constants.apiHost}/expenses/details/${expenseId}`, {
    headers: headersProvider(),
  });
